<select class="form-control" [(ngModel)]="value">
  <option *ngFor="let timeZone of timeZones" [value]="timeZone.UniqueId"> {{ timeZone.ShortName }} {{ timeZone.Name }} </option>
</select>
